import {Chip, Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../system/thead";
import {PaginateContext} from "../../context/paginate";
import {ServicePaymentContext} from "../../context/service_payment";

const TABLE_HEAD = [
  "#",
  "شناسه خدمت",
  "کاربر",
  "مباشر",
  "گرایش",
  "نوع پرداخت",
  "جمع کل",
  "تسویه شده",
  "لغو شده",
  "مانده",
  "وضعیت",
];

const headMap = {
  "#": "",
  "شناسه خدمت": "service_id",
  "کاربر": "person_name",
  "مشاور": "agent_name",
  "گرایش": "branch_name",
  "نوع پرداخت": "payment_type",
  "جمع کل": "total",
  "تسویه شده": "settled_amount",
  "لغو شده": "canceled_amount",
  "مانده": "remaining_amount",
  "وضعیت": "settlement_status",
};

const headSortable = {
  "#": false,
  "شناسه خدمت": true,
  "کاربر": true,
  "مشاور": true,
  "گرایش": true,
  "نوع پرداخت": true,
  "جمع کل": true,
  "تسویه شده": true,
  "لغو شده": true,
  "مانده": true,
  "وضعیت": true,
};

const statusDisplay = {
  "Ready to settle": {label: "آماده تسویه", color: "green"},
  "Waiting for step": {label: "در انتظار تکمیل مرحله", color: "amber"},
  "Settled": {label: "تسویه شده", color: "blue-gray"},
  "Canceled": {label: "لغو و عودت شده", color: "red"},
  "Closed": {label: "بسته شده", color: "gray"},
};

function getPaymentChip(payment_type, two_step_payment) {
  if (payment_type === "first" || two_step_payment) return {label: "دو مرحله‌ای", color: "purple"};
  if (payment_type === "total") return {label: "یک مرحله‌ای", color: "teal"};
  return {label: "-", color: "gray"};
}

export function ServicePaymentGrid() {

  const {setSortBy, sortType, setSortType} = useContext(PaginateContext);
  const {servicePayments, setServicePayment, setOpen} = useContext(ServicePaymentContext);
  const [selectedHead, setSelectedHead] = useState("#");

  return (
    <div className="w-full border border-blue-gray-100 rounded-xl overflow-hidden">
      <table className="w-full table-fixed">
        <colgroup>
          <col className="w-[4%]"/>
          <col className="w-[6%]"/>
          <col className="w-[10%]"/>
          <col className="w-[10%]"/>
          <col className="w-[14%]"/>
          <col className="w-[9%]"/>
          <col className="w-[9%]"/>
          <col className="w-[9%]"/>
          <col className="w-[8%]"/>
          <col className="w-[7%]"/>
          <col className="w-[14%]"/>
        </colgroup>
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter divide-y divide-blue-gray-50 px-4">
          {servicePayments.length === 0 && (
            <tr>
              <td colSpan={TABLE_HEAD.length} className="py-12 text-center">
                <Typography color="blue-gray" className="font-normal">
                  موردی یافت نشد
                </Typography>
              </td>
            </tr>
          )}
          {servicePayments.map(
            ({
               id,
               service_id,
               person_name,
               person_phone,
               agent_name,
               agent_phone,
               branch_name,
               payment_type,
               two_step_payment,
               total,
               settled_amount,
               canceled_amount,
               remaining_amount,
               settlement_status,
             }, index) => {
              const paymentChip = getPaymentChip(payment_type, two_step_payment);

              return (
                <tr
                  key={id}
                  onClick={() => {
                    setServicePayment(servicePayments[index]);
                    setOpen(true);
                  }}
                  className={`cursor-pointer transition-colors hover:bg-blue-gray-100/50 ${
                    index % 2 === 0 ? "bg-white" : "bg-blue-gray-50/30"
                  }`}
                >
                  <td className="p-2">
                    <div className="flex justify-center">
                      <Typography color="blue-gray">
                        {persianNumberFormat(index + 1, true)}
                      </Typography>
                    </div>
                  </td>

                  <td className="p-2">
                    <div className="flex justify-center px-2">
                      <Typography color="blue-gray" className="textRight break-words">
                        {persianNumberFormat(service_id || id)}
                      </Typography>
                    </div>
                  </td>

                  <td className="p-2">
                    <div className="flex flex-col justify-center px-2">
                      <Typography color="blue-gray" className="textRight break-words">
                        {person_name}
                      </Typography>
                      <Typography variant="small" color="gray" className="textRight break-words">
                        {persianNumberFormat(person_phone)}
                      </Typography>
                    </div>
                  </td>

                  <td className="p-2">
                    <div className="flex flex-col justify-center px-2">
                      <Typography color="blue-gray" className="textRight break-words">
                        {agent_name}
                      </Typography>
                      <Typography variant="small" color="gray" className="textRight break-words">
                        {persianNumberFormat(agent_phone)}
                      </Typography>
                    </div>
                  </td>

                  <td className="p-2">
                    <div className="flex justify-center px-2">
                      <Typography color="blue-gray" className="textRight break-words">
                        {branch_name}
                      </Typography>
                    </div>
                  </td>

                  <td className="p-2">
                    <div className="flex justify-center px-2">
                      <Chip
                        variant="ghost"
                        value={paymentChip.label}
                        color={paymentChip.color}
                        className="textCenter"
                      />
                    </div>
                  </td>

                  <td className="p-2">
                    <div className="flex justify-center px-2">
                      <Typography color="blue-gray" className="textRight break-words">
                        {persianNumberFormat(total, true)}
                      </Typography>
                    </div>
                  </td>

                  <td className="p-2">
                    <div className="flex justify-center px-2">
                      <Typography color="blue-gray" className="textRight break-words">
                        {persianNumberFormat(settled_amount, true)}
                      </Typography>
                    </div>
                  </td>

                  <td className="p-2">
                    <div className="flex justify-center px-2">
                      <Typography color="blue-gray" className="textRight break-words">
                        {persianNumberFormat(canceled_amount, true)}
                      </Typography>
                    </div>
                  </td>

                  <td className="p-2">
                    <div className="flex justify-center px-2">
                      <Typography color="blue-gray" className="textRight break-words">
                        {persianNumberFormat(remaining_amount, true)}
                      </Typography>
                    </div>
                  </td>

                  <td className="p-2">
                    <div className="flex justify-center px-2">
                      <Chip
                        variant="ghost"
                        value={statusDisplay[settlement_status]?.label || settlement_status}
                        color={statusDisplay[settlement_status]?.color || "gray"}
                        className="textCenter"
                      />
                    </div>
                  </td>
                </tr>
              );
            },
          )}
        </tbody>
      </table>
    </div>
  );
}
